import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pdf",
  "use": "icon-pdf-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-pdf\">\n    <path d=\"M6 3V10H8V5H24V10H26V3H6ZM8 12V20H10V18C11.6445 18 13 16.6445 13 15C13 13.3555 11.6445 12 10 12H8ZM14 12V20H16.5C17.8828 20 19 18.8828 19 17.5V14.5C19 13.1172 17.8828 12 16.5 12H14ZM20 12V20H22V17H24V15H22V14H25V12H20ZM10 14C10.5547 14 11 14.4453 11 15C11 15.5547 10.5547 16 10 16V14ZM16 14H16.5C16.7148 14 17 14.2852 17 14.5V17.5C17 17.7148 16.7148 18 16.5 18H16V14ZM6 22V29H26V22H24V27H8V22H6Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol